import numeral from 'numeral';
import React from 'react';
import { Nav } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

import PopoverTrigger from '../../PopoverTrigger';

import { setUserPreference } from '../../../helpers/user-preferences';

const tableLinkStyle = {
  margin: '0px',
  padding: '0px',
};

export function slashListFormatter(rowCallback) {
  const formatter = function (_cell, row) {
    return rowCallback(row).join(' / ');
  };

  return formatter;
}

export function linkFormatter(
  rowCallback,
  preferenceCallback = undefined,
  new_tab = undefined
) {
  const formatter = function (_cell, row) {
    const [url, label, currentLocation] = rowCallback(row);

    let localStorageKey = undefined;
    let localStorageValue = undefined;
    if (preferenceCallback) {
      [localStorageKey, localStorageValue] = preferenceCallback(row);
    }

    return (
      <>
        {url ? (
          <LinkContainer
            style={tableLinkStyle}
            onClick={
              localStorageKey
                ? () => setUserPreference(localStorageKey, localStorageValue)
                : () => {}
            }
            to={{ pathname: url, state: { previousLocation: currentLocation } }}
            target={new_tab ? '_blank' : ''}
            rel={new_tab ? 'noopener noreferrer' : ''}
          >
            <Nav.Link>{label}</Nav.Link>
          </LinkContainer>
        ) : (
          label
        )}
      </>
    );
  };

  return formatter;
}

export function fmtBoolYesNo(enrolled) {
  return enrolled === true ? 'Yes' : 'No';
}

export function fmtBoolExists(enrolled) {
  return enrolled ? 'Yes' : 'No';
}

export function fmtUSD(money) {
  return numeral(money).format('$0,0.00');
}

export const fmtLongString = (str) =>
  str.length < 26 ? (
    str
  ) : (
    <PopoverTrigger popoverContent={str} placement={'top'}>
      <span>{`${str.substring(0, 22)}...`}</span>
    </PopoverTrigger>
  );

export function SetPortfolioLinkFormatter(rowCallback) {
  const formatter = function (_cell, row) {
    const [url, label, setActivePortfolio] = rowCallback(row);
    return (
      <LinkContainer style={tableLinkStyle} to={url}>
        <Nav.Link
          onSelect={(selected) =>
            setActivePortfolio({
              id: label.id,
              name: label.name,
            })
          }
        >
          {label.name}
        </Nav.Link>
      </LinkContainer>
    );
  };
  return formatter;
}
